module.exports = __webpack_public_path__ + "static/img/book15.5c548eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book15.jpg
// module id = fz5y
// module chunks = 1